<template>
  <v-container>
    <v-layout justify-center>
      <v-flex md8 lg8 xs12>
        <v-form v-model="valid" ref="form">
          <v-card>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    prepend-inner-icon="mdi-format-title"
                    label="Título"
                    v-model="galeria.titulo"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="galeria.tipo_galeria_id"
                    :items="tip_galerias"
                    label="Tipo"
                    item-text="texto"
                    item-value="id"
                    required
                    :rules="rules"
                  ></v-select>
                </v-flex>

                <v-flex xs12>
                  <v-radio-group
                    row
                    v-model="galeria.enviar"
                    required
                    :rules="rules"
                  >
                    <v-radio
                      v-for="(option, index) in radioOptions"
                      :key="option"
                      color="primary"
                      :label="option"
                      :value="String(index)"
                    />
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Descrição"
                    v-model="galeria.descricao"
                    required
                    :rules="rules"
                    prepend-inner-icon="mdi-format-title"
                    hint="Descrição da galeria"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-menu
                    v-model="data"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="
                          galeria.data &&
                            moment(galeria.data).format('DD/MM/YYYY')
                        "
                        label="Data"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        clearable
                        v-on="on"
                        required
                        :rules="rules"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="galeria.data"
                      no-title
                      @input="data = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" dark @click="salvar()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Galeria } from '../../service'

export default {
  data() {
    return {
      radioOptions: ['Aluno', 'Responsavel', 'Ambos'],
      valid: false,
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      galeria: {
        tipo_galeria_id: '',
        status: 'C'
      },
      data: false,
      rules: [v => !!v || 'Campo requerido.'],
      tip_galerias: [{ id: 1, texto: 'Turma' }, { id: 2, texto: 'Aluno' }]
    }
  },
  async created() {
    if (this.$route.params.id) {
      this.galeria = await Galeria.findById(this.$route.params.id, {
        escola: this.escola
      })
      this.galeria.tipo_galeria_id = this.galeria.tipo_galeria.id
    }
    //console.log(this.galeria)
  },
  methods: {
    async salvar() {
      if (this.$refs.form.validate()) {
        const res = await Galeria.save(this.galeria, { escola: this.escola })
        this.$router.push(`/galerias/${res.id}`)
      }
    }
  }
}
</script>

<style></style>
